// extracted by mini-css-extract-plugin
module.exports = {"select":"MenuSelector__select___66Px5 Form__select___WbkWi","fieldset":"MenuSelector__fieldset___2v271","legend":"MenuSelector__legend___16ErU"};